export default function CalculatorSurface() {
  return (
    <div className="h-full flex items-center justify-center text-purple-300/50 text-sm">
      Drag components from the left to begin building your calculator
    </div>
  );
}
